<div class="p-4 lg:p-10">
  <div class="consents">
    <div class="grid gap-4 text-mat-ef-revolution-primary-500">
      <h2 class="font-canelablack text-4xl md:text-5xl">
        {{ 'data-protection' | sharedTranslate }}
      </h2>
      <div class="subtitle font-black">
        {{ 'data-protection' | sharedTranslate }}
      </div>
      <!-- prettier-ignore -->
      <div>
        <p [innerHTML]="getTranslationGdpr() | safeHtml"></p>
      </div>

      <form
        #consentsForm
        [action]="viewData.registrationAction"
        method="POST"
        [formGroup]="form"
      >
        <input type="hidden" name="step" value="gdpr" />
      </form>

      <div class="consent-button">
        <button
          mat-button
          mat-raised-button
          color="secondary"
          class="revolution w-full md:w-1/2 button-spinner"
          (click)="submit()"
          [disabled]="submitting"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="submitting"
          >
          </customer-portal-ef-spinner>
          {{ 'next' | sharedTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
